import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaTrash, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { ApiUrl } from "Services/Services";

const Announcement = () => {
  const [announcements, setAnnouncements] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newAnnouncement, setNewAnnouncement] = useState({
    title: "",
    message: "",
  });

  const fetchAnnouncements = async () =>{
   try {
    const response = await axios.get(`${ApiUrl}/announcement`);
    setAnnouncements(response.data?.data);
   } catch (error) {
    console.log(error)
   } 
  }

  useEffect(()=>{
    fetchAnnouncements()
  },[])
  const handleInputChange = (e) => {
    setNewAnnouncement({ ...newAnnouncement, [e.target.name]: e.target.value });
  };

  const handleAddAnnouncement = async() => {
    if (!newAnnouncement.title || !newAnnouncement.message) return;
    try{
      const payload = {
        title : newAnnouncement.title,
        body : newAnnouncement.message,
      }
      await axios.post(`${ApiUrl}/notification/send-notification` , payload);
      setNewAnnouncement({
    title: "",
    message: "",
  })
      fetchAnnouncements()
      toast.success('Notification send to all Users')
    }catch(error){
            toast.success(error.message)
    }
    setIsModalOpen(false);
  };

  const handleDelete = async(id) => {
    await axios.delete(`${ApiUrl}/announcement/${id}`);
    fetchAnnouncements();
    toast.success('Notification Deleted');
  };

  return (
    <div className="p-6">
      <div className="flex justify-end items-center mb-4">
        {/* <h1 className="text-2xl font-semibold">Announcements</h1> */}
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          <FaPlus /> Add Announcement
        </button>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        {announcements.length > 0 ? (
          <table className="min-w-full">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="px-6 py-4">#</th>
                <th className="px-6 py-4">Title</th>
                <th className="px-6 py-4">Message</th>
                <th className="px-6 py-4 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {announcements.map((item, index) => (
                <tr
                  key={item.id}
                  className="border-b hover:bg-gray-50 transition-all"
                >
                  <td className="px-6 py-4 font-medium text-gray-900">
                    {index + 1}
                  </td>
                  <td className="px-6 py-4">{item.title}</td>
                  <td className="px-6 py-4">{item.body}</td>
                  <td className="px-6 py-4 text-center">
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center py-6 text-gray-500 italic">
            No announcements yet.
          </div>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-xl animate-scaleIn">
            <h2 className="text-xl font-semibold mb-4">New Announcement</h2>
            <input
              name="title"
              placeholder="Title"
              value={newAnnouncement.title}
              onChange={handleInputChange}
              className="w-full border border-gray-300 px-4 py-2 mb-4 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
            />
            <textarea
              name="message"
              placeholder="Message"
              rows="4"
              value={newAnnouncement.message}
              onChange={handleInputChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
            />
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleAddAnnouncement}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Announcement;
